import { useState, useEffect } from "react";
import { Button, Modal, Card, Row, Col, Form } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import NoIndexSEO from "../../components/SEO/NoIndexSEO";
import { seoConfig } from "../../utils/seoConfig";
import { isDemoSite } from "../../utils/environment";
import { showError } from "../../components/toasts";
import SavedPaychecksSection from "./SavedPaychecksSection";
import SavedCitiesSection from "./SavedCitiesSection";
import GuidedTour from "../../components/tour/GuidedTour";
import useTour from "../../components/tour/useTour";
import getProfileTourSteps from "./profileTourSteps";
import FollowersModal from "./modals/FollowersModal";
import FollowingModal from "./modals/FollowingModal";

import { FiX, FiAlertCircle, FiAlertTriangle } from "react-icons/fi";

import EditProfileModal from "./EditProfileModal";
import RoleSelectionModal from "./Modals/RoleSelectionModal"; //add
import YearsOfExperienceModal from "./Modals/YearsOfExperienceModal";
import LocationChoiceModal from "./Modals/YourLocationChoiceModal"; // add
import CitySelectionModal from "./Modals/YourCurrentCityModal"; // add
import StateSelectionModal from "./Modals/SelectStateModal";
import SocialProfilesStep from "./Modals/SocialProfilesStep";
import ContractDocumentModal from "./Modals/ContractDocumentModal";
import SalaryModal from "./Modals/salaryModel";

import { ReactComponent as SubscriptionIcon } from "../../assets/images/subscription.svg";
import { ReactComponent as RightArrowIcon } from "../../assets/images/right-arrow.svg";
import { ReactComponent as ContactUsIcon } from "../../assets/images/contact-us.svg";
import { ReactComponent as ChangePasswordIcon } from "../../assets/images/change-password.svg";

import { ReactComponent as EyeOff } from "../../assets/images/eyeOff-icon.svg";
import { ReactComponent as Eye } from "../../assets/images/eye-icon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import { ReactComponent as DeleteAccountModalIcon } from "../../assets/images/delete-modal-account.svg";
import Edit from "../../assets/images/edit-icon.svg";
import Img from "../../assets/images/user-profile.png";

import { ReactComponent as FormLabelFacebook } from "../../assets/images/form-label-facebook.svg";
import { ReactComponent as FormLabelIntagram } from "../../assets/images/form-label-intagram.svg";
import { ReactComponent as FormLabelLinkedIn } from "../../assets/images/form-label-linkedin.svg";
import { EditIcon, EyeIcon } from "lucide-react";
import { getViewProfile } from "../../redux/slices/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import ContractSecondDocumentModal from "./Modals/ContractSecondDocumentModal";
import { changePassword, deleteAccount } from "../../redux/slices/authSlice";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { ReactComponent as ReferralIcon } from "../../assets/images/referral.svg";
import {
  activityEnd,
  activityStart,
} from "../../redux/slices/trackActivitySlice";
import usePageTracking from "../../hooks/usePageTracking";
import ShiftTypeModal from "./Modals/ShiftTypeModal";
import CommunityNotificationModal from "./Modals/communityNotificationModal";
import { getNotificationPreferencesCategories } from "../../redux/slices/notificationSlice";
import JobsNotificationModal from "./Modals/jobsNotificationModal";
import FeatureNotificationModal from "./Modals/fratureNotificationModal";
import NewsletterNotificationModal from "./Modals/newsletterNotificationModal";
import SystemNotificationModal from "./Modals/systemNotificationModal";
import PromotionsNotificationModal from "./Modals/promotionsNotificationModal";
import CertificateModal from "./Modals/certificateModal";
import EmploymentTypeModal from "./Modals/employmentModal";
import CareerObjectivesModal from "./Modals/careerObjectiveModal";
import NurseCurrentCityModal from "./Modals/nurseCurrentCityModal";
import RelocationModal from "./Modals/willingToRelocateModal";
import LicenseTypeModal from "./Modals/licenseTypeModal";
import CompactLicenseModal from "./Modals/compactNursingLicenseModal";
import LicenseNumberModal from "./Modals/licenseNumberModal";
import LicenseVerifiedModal from "./Modals/LicenseVerifiedModal";
import YearsExperienceModal from "./Modals/YearsExperienceModal";
import PrimarySpecialtyModal from "./Modals/primarySpecialtyModal";
import EducationModal from "./Modals/educationModal";
import AvailableToStartModal from "./Modals/availableToStartModal";
import BedsideLast12MonthsModal from "./Modals/bedsideLast12MonthsModal";
import PatientPopulationModal from "./Modals/patientPopulationModal";
import TraumaLevelExperienceModal from "./Modals/traumaLevelExperienceModal";
import CertsUploadedModal from "./Modals/certsUploadedModal";
import ResumeUploadedModal from "./Modals/resumeUploadedModal";
import ResumeUrlModal from "./Modals/resumeUrlModal";
import AvailabilitySetModal from "./Modals/availabilitySetModal";
import PreferencesConfirmedModal from "./Modals/preferencesConfirmedModal";
import PreferredStatesModal from "./Modals/preferredStatesModal";
import LicensedStatesModal from "./Modals/licensedStatesModal";
import AdditionalSpecialtiesModal from "./Modals/additionalSpecialtiesModal";
import ShiftPreferencesModal from "./Modals/shiftPreferencesModal";
import EmrSystemsModal from "./Modals/emrSystemsModal";
import {
  PlanShield,
  UpgradePlanModal,
} from "../../components/subscription/UpgradePlanModal";
import {
  PROFILE_COMPLETION_FIELDS,
  getProfileCompletionPercent,
} from "../../utils/profileCompletion";

const ProfileComponent = (onChangePassword, buttonText = "Save Changes") => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  const [searchParams, setSearchParams] = useSearchParams();

  const authStore = useSelector((state) => state.auth);
  const regType = authStore?.user?.reg_type;

  const [showUpgrade, setShowUpgrade] = useState(false); // plan-badge upgrade modal
  const [showRoleModal, setShowRoleModal] = useState(false); // add
  const [showShiftModal, setShowShiftModal] = useState(false);
  const [showSalaryModal, setShowSalaryModal] = useState(false); // add
  const [showExperienceModal, setShowExperienceModal] = useState(false); // add
  const [showLocationChoiceModal, setShowLocationChoiceModal] = useState(false); // add
  const [showContractModal, setShowContractModal] = useState(false);
  const [secondContractFile, setSecondContractFile] = useState(null);
  const [showSecondContractModal, setSecondShowContractModal] = useState(false);
  const [showSocialModal, setShowSocialModal] = useState(false);
  const [showCityModal, setShowCityModal] = useState(false);
  const [showDestinationModal, setShowDestinationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [showNurseCurrentCityModal, setShowNurseCurrentCityModal] = useState(
    false,
  );
  const [showWillingToRelocateModal, setShowWillingToRelocateModal] = useState(
    false,
  );
  const [
    showHasCompactNursingLicenseModal,
    setShowHasCompactNursingLicenseModal,
  ] = useState(false);
  const [
    showIsLicenseHasBeenVerifiedModal,
    setShowIsLicenseHasBeenVerifiedModal,
  ] = useState(false);
  const [showPrimarySpecialtyModal, setShowPrimarySpecialtyModal] = useState(
    false,
  );
  const [showAvailableToStartModal, setShowAvailableToStartModal] = useState(
    false,
  );
  const [
    showTraumaLevelExperienceModal,
    setShowTraumaLevelExperienceModal,
  ] = useState(false);
  const [showCertsUploadedModal, setShowCertsUploadedModal] = useState(false);
  const [showResumeUrlModal, setShowResumeUrlModal] = useState(false);
  const [
    showPreferencesConfirmedModal,
    setShowPreferencesConfirmedModal,
  ] = useState(false);
  const [showResumeUploadedModal, setShowResumeUploadedModal] = useState(false);
  const [showAvailabilitySetModal, setShowAvailabilitySetModal] = useState(
    false,
  );
  const [showPreferredStatesModal, setShowPreferredStatesModal] = useState(
    false,
  );
  const [showShiftPreferencesModal, setShowShiftPreferencesModal] = useState(
    false,
  );
  const [showEmrSystemsModal, setShowEmrSystemsModal] = useState(false);
  const [
    showAdditionalSpecialtiesModal,
    setShowAdditionalSpecialtiesModal,
  ] = useState(false);
  const [showLicensedStatesModal, setShowLicensedStatesModal] = useState(false);

  const [
    showCommunityNotificationModal,
    setShowCommunityNotificationModal,
  ] = useState(false);
  const [showJobsNotificationModal, setShowJobsNotificationModal] = useState(
    false,
  );
  const [
    showFeaturesNotificationModal,
    setShowFeaturesNotificationModal,
  ] = useState(false);
  const [
    showNewsletterNotificationModal,
    setShowNewsletterNotificationModal,
  ] = useState(false);
  const [
    showSystemNotificationModal,
    setShowSystemNotificationModal,
  ] = useState(false);
  const [
    showPromotionsNotificationModal,
    setShowPromotionsNotificationModal,
  ] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [showEmploymentModal, setShowEmploymentModal] = useState(false);
  const [showLicenseTypeModal, setShowLicenseTypeModal] = useState(false);
  const [showLicenseNumberModal, setShowLicenseNumberModal] = useState(false);
  const [showYearsExperienceModal, setShowYearsExperienceModal] = useState(
    false,
  );
  const [
    showNursingEducationLevelModal,
    setShowNursingEducationLevelModal,
  ] = useState(false);
  const [
    showBedsideLast12MonthsModal,
    setShowBedsideLast12MonthsModal,
  ] = useState(false);
  const [showPatientPopulationModal, setShowPatientPopulationModal] = useState(
    false,
  );

  const [showCareerObjectiveModal, setShowCareerObjectiveModal] = useState(
    false,
  );

  // Follow stats state
  const [followStats, setFollowStats] = useState({
    followers: 0,
    following: 0,
    loading: true,
  });

  // Modal states for followers and following
  const [showFollowersModal, setShowFollowersModal] = useState(false);
  const [showFollowingModal, setShowFollowingModal] = useState(false);

  // Accordion state for mobile view
  const [isOtherDetailsOpen, setIsOtherDetailsOpen] = useState(false);

  const [passwords, setPasswords] = useState({
    old: "",
    new: "",
    confirm: "",
  });

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  // Helper function to update URL with modal parameter
  const openModalWithParam = (modalName, setModalState) => {
    setSearchParams({ modal: modalName });
    setModalState(true);
  };

  // Helper function to close modal and remove URL parameter
  const closeModalAndClearParam = (setModalState) => {
    setSearchParams({});
    setModalState(false);
  };

  const [message, setMessage] = useState(""); // success message
  const [error, setError] = useState(""); // error message

  const schema = Yup.object().shape({
    old: Yup.string().required("Old password is required"),
    new: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters long")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&])/,
        "Password must include uppercase, lowercase, number, and special character",
      ),
    confirm: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("new"), null], "Passwords must match"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const defaultProfile = {
    name: "John Doe",
    email: "loremipsum@gmail.com",
    profileImage: Img,
  };

  const [profile, setProfile] = useState(defaultProfile);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const handleEditProfileClick = () => setShowEditProfileModal(true);
  const [showCompletionChecklist, setShowCompletionChecklist] = useState(
    false,
  );
  const handleModalSave = (updatedProfile) => {
    setProfile((prev) => ({ ...prev, ...updatedProfile }));
    setShowEditProfileModal(false);
  };

  const handleClickChangePassword = () => {
    if (isDemoSite()) {
      showError("Not available in the demo");
      return;
    }
    // navigate('/profile/change-password')
    setShowModal(true);
  };

  // toggle show/hide password
  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  // handle form submit
  const onSubmit = (passwords) => {
    // e.preventDefault();
    setError("");
    setMessage("");
    const payload = {
      old_password: passwords?.old,
      new_password: passwords?.new,
      confirm_password: passwords?.confirm,
    };
    dispatch(changePassword(payload));
  };

  useEffect(() => {
    if (authStore?.actionFlag === "DELETE_ACCOUNT_SUCCESS") {
      navigate("/login");
    }
  }, [authStore?.actionFlag, navigate]);

  useEffect(() => {
    if (authStore?.successMessage) {
      setShowModal(false);
    }
  }, [authStore?.successMessage]);

  const handleDelete = () => {
    // toast.success("Account deleted successfully!");

    setShowDeleteAccountModal(false);
    dispatch(deleteAccount());
    // setTimeout(() => {
    //   navigate("/login");
    // }, 1000);
  };

  const [currentRole, setCurrentRole] = useState({
    value: "Registered Nurse (RN)",
    isEditing: false,
  });

  const [careerObjectives, setCareerObjectives] = useState({
    value: ["1. Higher Compensation", "2. Better Work-Life Balance"],
    isEditing: false,
  });

  const [socialProfiles, setSocialProfiles] = useState({});

  useEffect(() => {
    if (store?.profileItem?.data) {
      setSocialProfiles({
        facebook: {
          icon: <FormLabelFacebook />,
          value: store?.profileItem?.data?.fb_profile_url,
          isEditing: false,
        },
        linkedin: {
          icon: <FormLabelLinkedIn />,
          value: store?.profileItem?.data?.linkedin_profile_url,
          isEditing: false,
        },
        instagram: {
          icon: <FormLabelIntagram />,
          value: store?.profileItem?.data?.insta_profile_url,
          isEditing: false,
        },
      });
    }
  }, [store]);

  const [contractFile, setContractFile] = useState(null);

  const [nursingExperience, setNursingExperience] = useState({
    value: "Nursing Student",
    isEditing: false,
  });

  const [currentLocationChoice, setCurrentLocationChoice] = useState({
    value: "Higher Salary Potential",
    isEditing: false,
  });

  const [currentCities, setCurrentCities] = useState({
    current: { state: null, city: null },
    destination: { state: null, city: null },
  });

  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    const docsPath = store?.profileItem?.data?.docs_one_path;
    if (docsPath) {
      setContractFile(
        `${process.env.REACT_APP_API_BASE_URL}/uploads/user_docs/${docsPath}`,
      );
    }
  }, [store?.profileItem?.data?.docs_one_path]);

  useEffect(() => {
    const docsPath = store?.profileItem?.data?.docs_two_path;
    if (docsPath) {
      setSecondContractFile(
        `${process.env.REACT_APP_API_BASE_URL}/uploads/user_docs/${docsPath}`,
      );
    }
  }, [store?.profileItem?.data?.docs_one_path]);

  const handleSimpleEditToggle = (setter) => {
    setter((prev) => ({ ...prev, isEditing: !prev.isEditing }));
  };

  useEffect(() => {
    dispatch(getViewProfile());
  }, []);

  // Helper function to safely parse data that might be a string or already parsed
  const safeParse = (data) => {
    if (!data) return [];
    if (typeof data === "string") {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.error("Failed to parse data:", e);
        return [];
      }
    }
    return Array.isArray(data) ? data : [];
  };

  usePageTracking("PROFILE");

  useEffect(() => {
    const payload = {
      page_name: "PROFILE",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "PROFILE",
        }),
      );
    };
  }, [dispatch]);

  useEffect(() => {
    if (!showModal) return;

    // Modal opened — start a tracking session
    dispatch(
      activityStart({ page_name: "CHANGE_PASSWORD_MODAL", platform: "web" }),
    );

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_PASSWORD_MODAL" }));
    };
  }, [showModal]);

  useEffect(() => {
    if (!showModal) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "DELETE_ACCOUNT", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "DELETE_ACCOUNT" }));
    };
  }, [showModal]);
  useEffect(() => {
    dispatch(getNotificationPreferencesCategories());
  }, [dispatch]);

  // Handle URL parameters to open specific modals
  useEffect(() => {
    const modal = searchParams.get("modal");
    if (modal) {
      const modalMap = {
        "community-notification": setShowCommunityNotificationModal,
        "jobs-notification": setShowJobsNotificationModal,
        "features-notification": setShowFeaturesNotificationModal,
        "newsletter-notification": setShowNewsletterNotificationModal,
        "system-notification": setShowSystemNotificationModal,
        "promotions-notification": setShowPromotionsNotificationModal,
        role: setShowRoleModal,
        "career-objective": setShowCareerObjectiveModal,
        education: setShowNursingEducationLevelModal,
        experience: setShowExperienceModal,
        "available-to-start": setShowAvailableToStartModal,
        "employment-type": setShowEmploymentModal,
        specialties: setShowAdditionalSpecialtiesModal,
        "trauma-level": setShowTraumaLevelExperienceModal,
        "patient-population": setShowPatientPopulationModal,
        "bedside-12-months": setShowBedsideLast12MonthsModal,
        "emr-systems": setShowEmrSystemsModal,
        certificate: setShowCertificateModal,
        "certs-uploaded": setShowCertsUploadedModal,
        "license-type": setShowLicenseTypeModal,
        "license-number": setShowLicenseNumberModal,
        "licensed-states": setShowLicensedStatesModal,
        "compact-license": setShowHasCompactNursingLicenseModal,
        "license-verified": setShowIsLicenseHasBeenVerifiedModal,
        "nurse-current-city": setShowNurseCurrentCityModal,
        "work-city": setShowCityModal,
        "willing-to-relocate": setShowWillingToRelocateModal,
        "interested-states": setShowDestinationModal,
        "preferred-states": setShowPreferredStatesModal,
        "location-choice": setShowLocationChoiceModal,
        salary: setShowSalaryModal,
        "shift-preferences": setShowShiftPreferencesModal,
        "preferences-confirmed": setShowPreferencesConfirmedModal,
        "contract-document": setShowContractModal,
        "pay-stubs": setSecondShowContractModal,
        "resume-url": setShowResumeUrlModal,
        "resume-uploaded": setShowResumeUploadedModal,
        "social-profiles": setShowSocialModal,
        "change-password": setShowModal,
        "delete-account": setShowDeleteAccountModal,
      };

      const setModalState = modalMap[modal];
      if (setModalState) {
        setModalState(true);
      }
    }
  }, [searchParams]);

  const experienceOptions = [
    { value: "<1", label: "Less than 1 year" },
    { value: "1-2", label: "1 - 2 years" },
    { value: "2-5", label: "2 - 5 years" },
    { value: "5-10", label: "5 - 10 years" },
    { value: "10+", label: "10+ years" },
  ];
  const educationOptions = [
    {
      value: "No formal education required",
      label: "No Formal Education Required",
    },
    { value: "High School Diploma / GED", label: "High School Diploma / GED" },
    { value: "CNA Certification", label: "CNA Certification" },
    { value: "LPN/LVN Certificate", label: "LPN / LVN Certificate" },
    {
      value: "Bachelor's in Health Administration (BHA)",
      label: "Bachelor's in Health Administration (BHA)",
    },
    {
      value: "Bachelor's in a Related Field",
      label: "Bachelor's in a Related Field",
    },
    {
      value: "Master's in Health Administration (MHA)",
      label: "Master's in Health Administration (MHA)",
    },
    { value: "ADN", label: "ADN (Associate Degree in Nursing)" },
    { value: "BSN", label: "BSN (Bachelor of Science in Nursing)" },
    { value: "MSN", label: "MSN (Master of Science in Nursing)" },
    { value: "DNP", label: "DNP (Doctor of Nursing Practice)" },
    { value: "PhD", label: "PhD (Doctor of Philosophy in Nursing)" },
  ];

  // Profile completion progress — read-only checks against existing profile
  // data, does not alter any existing state or API calls. The field list
  // and weights live in utils/profileCompletion so the header nav badge
  // computes the exact same percentage.
  const profileData = store?.profileItem?.data;
  const completionActionMap = {
    photo: handleEditProfileClick,
    full_name: handleEditProfileClick,
    city: () => setShowCityModal(true),
    role: () => setShowRoleModal(true),
    experience: () => setShowExperienceModal(true),
    career_objective: () => setShowCareerObjectiveModal(true),
    salary: () => setShowSalaryModal(true),
    license_number: () => setShowLicenseNumberModal(true),
    resume: () => setShowResumeUploadedModal(true),
    social_profiles: () => setShowSocialModal(true),
  };
  const completionItems = PROFILE_COMPLETION_FIELDS.map((field) => ({
    ...field,
    isComplete: field.isComplete(profileData),
    onClick: completionActionMap[field.key],
  }));
  const profileCompletionPercent = getProfileCompletionPercent(profileData);
  const incompleteCompletionItems = completionItems.filter(
    (item) => !item.isComplete,
  );

  // Guided tour — auto-starts on the user's first visit to the profile page
  // and is replayable from the header's tour button (pageKey "profile").
  const { isOpen: isTourOpen, finish: finishTour } = useTour("profile");

  return (
    <div className="profile-content">
      <NoIndexSEO title={seoConfig.profile.title} />
      <GuidedTour
        isOpen={isTourOpen}
        steps={getProfileTourSteps()}
        onDone={finishTour}
      />
      {/* <h1>Profile</h1> */}
      <div className="app-page-title">
        <div className="page-title-heading">
          <h3 className="page-title">Profile</h3>
        </div>
      </div>

      {/* Profile Completion Banner */}
      {store?.profileItem?.data && profileCompletionPercent < 100 && (
        <div
          className="profile-completion-banner"
          role="button"
          tabIndex={0}
          onClick={() => setShowCompletionChecklist((prev) => !prev)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setShowCompletionChecklist((prev) => !prev);
            }
          }}
        >
          <div className="profile-completion-banner-head">
            <div className="profile-completion-banner-title">
              <span className="profile-completion-banner-eyebrow">
                Complete your profile
              </span>
              <span className="profile-completion-banner-sub">
                Complete your profile to get matched with more jobs
              </span>
            </div>
            <div className="profile-completion-banner-pct">
              {profileCompletionPercent}%
            </div>
          </div>
          <div className="profile-completion-bar-track">
            <div
              className="profile-completion-bar-fill"
              style={{ width: `${profileCompletionPercent}%` }}
            ></div>
          </div>
          {showCompletionChecklist && incompleteCompletionItems.length > 0 && (
            <ul
              className="profile-completion-checklist"
              onClick={(e) => e.stopPropagation()}
            >
              {incompleteCompletionItems.map((item) => (
                <li
                  key={item.key}
                  onClick={(e) => {
                    e.stopPropagation();
                    item.onClick();
                  }}
                >
                  <span>{item.label}</span>
                  <span className="profile-completion-checklist-arrow">
                    ›
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      <Card>
        <Card.Body className="p-0">
          <Row className="m-0">
            {/* === Left Column: Profile Card === */}
            <Col md={5} xl={4} className="p-0">
              <div className="profile-card h-100" data-tour="pf-profile">
                <div className="profile-image-container">
                  <img
                    src={`${process.env.REACT_APP_API_BASE_URL}/uploads/user_profile/${store?.profileItem?.data?.profile_photo_path}`}
                    alt="Profile"
                    className="profile-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        store?.profileItem?.data?.full_name || "User",
                      )}&background=0195D3&color=fff&size=200`;
                    }}
                  />
                  <Button
                    onClick={handleEditProfileClick}
                    className="btn btn-secondary d-block d-md-none"
                    data-tour="pf-edit"
                  >
                    <EditIcon size={14} />
                  </Button>
                </div>
                {/* Plan badge + upgrade-modal click commented out per request
                <h5
                  role="button"
                  tabIndex={0}
                  onClick={() => setShowUpgrade(true)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setShowUpgrade(true);
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  title="View upgrade options"
                >
                  {store?.profileItem?.data?.full_name}
                  <PlanShield
                    planName={
                      authStore?.user?.plan?.name ||
                      store?.profileItem?.data?.plan?.name
                    }
                    onClick={() => setShowUpgrade(true)}
                  />
                </h5>
                */}
                <h5>{store?.profileItem?.data?.full_name}</h5>
                <p>{store?.profileItem?.data?.email}</p>

                {/* Followers and Following Section */}
                <div className="followers-following-section">
                  <div
                    className="stat-item clickable"
                    onClick={() => setShowFollowersModal(true)}
                    style={{ cursor: "pointer" }}
                    data-tour="pf-followers"
                  >
                    <div className="stat-number">
                      {store?.profileItem?.data?.followers_count}
                    </div>
                    <div className="stat-label">Followers</div>
                  </div>
                  <div className="stat-divider"></div>
                  <div
                    className="stat-item clickable"
                    onClick={() => setShowFollowingModal(true)}
                    style={{ cursor: "pointer" }}
                    data-tour="pf-following"
                  >
                    <div className="stat-number">
                      {store?.profileItem?.data?.following_count}
                    </div>
                    <div className="stat-label">Following</div>
                  </div>
                </div>

                <div className="table-responsive" data-tour="pf-nameemail">
                  <table className="profile-details-table">
                    <tbody>
                      <tr data-tour="pf-name">
                        <th>Name</th>
                        <td>{store?.profileItem?.data?.full_name}</td>
                      </tr>
                      <tr data-tour="pf-email">
                        <th>Email Address</th>
                        <td>{store?.profileItem?.data?.email}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <Button
                  onClick={handleEditProfileClick}
                  className="btn btn-secondary d-none d-md-block text-center mx-auto"
                  data-tour="pf-edit"
                >
                  Edit Profile
                </Button>
                <div className="other-details-card text-start" data-tour="pf-notif">
                  <div
                    className="form-group-item d-flex justify-content-between"
                    onClick={() =>
                      openModalWithParam(
                        "community-notification",
                        setShowCommunityNotificationModal,
                      )
                    }
                  >
                    <div className="content">
                      <label>Community notification</label>
                    </div>

                    <button
                      className="btn btn-link p-0 text-decoration-none"
                      data-tour="pf-notif-edit"
                      onClick={() =>
                        openModalWithParam(
                          "community-notification",
                          setShowCommunityNotificationModal,
                        )
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  </div>
                  <div
                    className="form-group-item d-flex justify-content-between"
                    onClick={() =>
                      openModalWithParam(
                        "jobs-notification",
                        setShowJobsNotificationModal,
                      )
                    }
                  >
                    <div className="content">
                      <label>Jobs notification</label>
                    </div>

                    <button
                      className="btn btn-link p-0 text-decoration-none"
                      onClick={() =>
                        openModalWithParam(
                          "jobs-notification",
                          setShowJobsNotificationModal,
                        )
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  </div>
                  <div
                    className="form-group-item d-flex justify-content-between"
                    onClick={() =>
                      openModalWithParam(
                        "features-notification",
                        setShowFeaturesNotificationModal,
                      )
                    }
                  >
                    <div className="content">
                      <label>Features notification</label>
                    </div>

                    <button
                      className="btn btn-link p-0 text-decoration-none"
                      onClick={() =>
                        openModalWithParam(
                          "features-notification",
                          setShowFeaturesNotificationModal,
                        )
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  </div>
                  <div
                    className="form-group-item d-flex justify-content-between"
                    onClick={() =>
                      openModalWithParam(
                        "newsletter-notification",
                        setShowNewsletterNotificationModal,
                      )
                    }
                  >
                    <div className="content">
                      <label>Newsletter notification</label>
                    </div>

                    <button
                      className="btn btn-link p-0 text-decoration-none"
                      onClick={() =>
                        openModalWithParam(
                          "newsletter-notification",
                          setShowNewsletterNotificationModal,
                        )
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  </div>
                  {/* <div className="form-group-item d-flex justify-content-between  ">
                    <div className="content">
                      <label>System notification</label>
                    </div>

                    <button
                      className="btn btn-link p-0 text-decoration-none"
                      onClick={() => openModalWithParam('system-notification', setShowSystemNotificationModal)}
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  </div> */}
                  <div
                    className="form-group-item d-flex justify-content-between"
                    onClick={() =>
                      openModalWithParam(
                        "promotions-notification",
                        setShowPromotionsNotificationModal,
                      )
                    }
                  >
                    <div className="content">
                      <label>Promotions notification</label>
                    </div>

                    <button
                      className="btn btn-link p-0 text-decoration-none"
                      onClick={() =>
                        openModalWithParam(
                          "promotions-notification",
                          setShowPromotionsNotificationModal,
                        )
                      }
                    >
                      <img src={Edit} alt="Edit" />
                    </button>
                  </div>
                </div>
              </div>
            </Col>

            {/* === Right Column: Other Details Form === */}
            <Col md={7} xl={8} className="p-0">
              <div
                className={`other-details-card h-100 ${
                  !isOtherDetailsOpen ? "collapsed" : ""
                }`}
              >
                <h4
                  className="d-flex justify-content-between align-items-center other-details-header"
                  onClick={() => setIsOtherDetailsOpen(!isOtherDetailsOpen)}
                  data-tour="pf-other-head"
                >
                  <span>Other Details</span>
                  <span className="d-md-none">
                    {isOtherDetailsOpen ? "−" : "+"}
                  </span>
                </h4>
                <div
                  className={`other-details-content ${
                    isOtherDetailsOpen ? "open" : ""
                  }`}
                >
                  <div className="row g-4">
                    {/* Left Column (Professional & Clinical) */}
                    <div className="col-md-6 mt-1">
                      {/* Role & Career */}
                      <div
                        className="form-group-item"
                        onClick={() => setShowRoleModal(true)}
                      >
                        <div className="content">
                          <label>What best describes your current role?</label>
                          <p>
                            {store?.profileItem?.data?.nursing_role?.role_title
                              ? store?.profileItem?.data?.nursing_role
                                  ?.role_title
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowRoleModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowCareerObjectiveModal(true)}
                      >
                        <div className="content">
                          <label>
                            What are your primary career objectives?
                          </label>
                          <p>
                            {(() => {
                              const careerObjectives = safeParse(
                                store?.profileItem?.data?.career_objective,
                              );
                              return careerObjectives.length > 0
                                ? careerObjectives.map((obj, index) => (
                                    <div key={obj.id || index}>
                                      {obj.career_title}
                                    </div>
                                  ))
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowCareerObjectiveModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowNursingEducationLevelModal(true)}
                      >
                        <div className="content">
                          <label>Nursing education level</label>
                          <p>
                            {(() => {
                              const exp =
                                store?.profileItem?.data?.nurseProfile
                                  ?.education;
                              const option = educationOptions.find(
                                (opt) => opt.value === exp,
                              );
                              return option ? option.label : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() =>
                            setShowNursingEducationLevelModal(true)
                          }
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowExperienceModal(true)}
                      >
                        <div className="content">
                          <label>
                            How many years of nursing experience do you have?
                          </label>
                          <p>
                            {store?.profileItem?.data?.nursing_experience
                              ?.experience_title
                              ? store?.profileItem?.data?.nursing_experience
                                  ?.experience_title
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowExperienceModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowAvailableToStartModal(true)}
                      >
                        <div className="content">
                          <label>Available to start</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.available_to_start
                              ? store.profileItem.data.nurseProfile
                                  .available_to_start
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowAvailableToStartModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowEmploymentModal(true)}
                      >
                        <div className="content">
                          <label>Preferred Employment type</label>
                          <p>
                            {(() => {
                              const employmentTypes = safeParse(
                                store?.profileItem?.data?.nurseProfile
                                  ?.employment_types,
                              );
                              return employmentTypes.length > 0
                                ? employmentTypes.join(", ")
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowEmploymentModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowAdditionalSpecialtiesModal(true)}
                      >
                        <div className="content">
                          <label>Specialties</label>
                          <p>
                            {(() => {
                              const nurseProfile =
                                store?.profileItem?.data?.nurseProfile;
                              const primarySpecialty =
                                nurseProfile?.primary_specialty;
                              const additionalSpecialties = safeParse(
                                nurseProfile?.additional_specialties,
                              );
                              const allSpecialties = [];
                              if (primarySpecialty)
                                allSpecialties.push(primarySpecialty);
                              allSpecialties.push(...additionalSpecialties);
                              return allSpecialties.length > 0
                                ? allSpecialties.map((item, index) => (
                                    <div key={index}>{item}</div>
                                  ))
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() =>
                            setShowAdditionalSpecialtiesModal(true)
                          }
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowTraumaLevelExperienceModal(true)}
                      >
                        <div className="content">
                          <label>Trauma level experience</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.trauma_level_exp
                              ? store.profileItem.data.nurseProfile
                                  .trauma_level_exp
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() =>
                            setShowTraumaLevelExperienceModal(true)
                          }
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowPatientPopulationModal(true)}
                      >
                        <div className="content">
                          <label>Patient population</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.patient_population
                              ? store.profileItem.data.nurseProfile
                                  .patient_population
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowPatientPopulationModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowBedsideLast12MonthsModal(true)}
                      >
                        <div className="content">
                          <label>Bedside work in the last 12 months</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.bedside_last_12mo === true
                              ? "Yes"
                              : store?.profileItem?.data?.nurseProfile
                                  ?.bedside_last_12mo === false
                              ? "No"
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowBedsideLast12MonthsModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowEmrSystemsModal(true)}
                      >
                        <div className="content">
                          <label>EMR systems experience</label>
                          <p>
                            {(() => {
                              const emrSystems = safeParse(
                                store?.profileItem?.data?.nurseProfile
                                  ?.emr_systems,
                              );
                              return emrSystems.length > 0
                                ? emrSystems.join(", ")
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowEmrSystemsModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      {/* Certs */}
                      <div
                        className="form-group-item"
                        onClick={() => setShowCertificateModal(true)}
                      >
                        <div className="content">
                          <label>Preferred certificate</label>
                          <p>
                            {(() => {
                              const certifications = safeParse(
                                store?.profileItem?.data?.nurseProfile
                                  ?.certifications,
                              );
                              return certifications.length > 0
                                ? certifications.join(", ")
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowCertificateModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowCertsUploadedModal(true)}
                      >
                        <div className="content">
                          <label>Have you uploaded your certifications?</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.certs_uploaded === true
                              ? "Yes"
                              : store?.profileItem?.data?.nurseProfile
                                  ?.certs_uploaded === false
                              ? "No"
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowCertsUploadedModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>
                      {/* Social Profiles */}
                      <div
                        className="form-group-social-item"
                        onClick={() => setShowSocialModal(true)}
                      >
                        <label className="social-label">
                          Connect your social profiles
                          <button
                            className="btn btn-link p-0 text-decoration-none"
                            onClick={() => setShowSocialModal(true)}
                          >
                            <img src={Edit} alt="Edit" />
                          </button>
                        </label>
                        {Object.keys(socialProfiles).map((key) => (
                          <div key={key} className="form-group-item">
                            <div className="content">
                              <label>
                                <span>{socialProfiles[key].icon}</span>
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                              </label>
                              <p>{socialProfiles[key].value}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowResumeUploadedModal(true)}
                      >
                        <div className="content">
                          <label>Have you uploaded your resume?</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.resume_uploaded === true
                              ? "Yes"
                              : store?.profileItem?.data?.nurseProfile
                                  ?.resume_uploaded === false
                              ? "No"
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowResumeUploadedModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowResumeUrlModal(true)}
                      >
                        <div className="content">
                          <label>Resume URL</label>
                          {(() => {
                            const resumeUrl =
                              store?.profileItem?.data?.nurseProfile
                                ?.resume_url;
                            const isValidUrl =
                              resumeUrl &&
                              /^(https?:\/\/)?(www\.)?([a-z0-9-]+\.)+[a-z]{2,}/i.test(
                                resumeUrl,
                              );
                            if (!resumeUrl)
                              return <p className="text-muted">Not Set</p>;
                            if (isValidUrl)
                              return (
                                <p className="resume-link">
                                  <a
                                    href={resumeUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {resumeUrl}
                                  </a>
                                </p>
                              );
                            return <p>{resumeUrl}</p>;
                          })()}
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowResumeUrlModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>
                    </div>

                    {/* Right Column (Licensing, Location, Salary & Docs) */}
                    <div className="col-md-6 mt-0">
                      {/* Licensing */}
                      <div
                        className="form-group-item"
                        onClick={() => setShowLicenseTypeModal(true)}
                      >
                        <div className="content">
                          <label>License Type</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.license_type
                              ? store.profileItem.data.nurseProfile.license_type
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowLicenseTypeModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowLicenseNumberModal(true)}
                      >
                        <div className="content">
                          <label>License Number</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.license_number
                              ? store.profileItem.data.nurseProfile
                                  .license_number
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowLicenseNumberModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowLicensedStatesModal(true)}
                      >
                        <div className="content">
                          <label>Licensed States</label>
                          <p>
                            {(() => {
                              const licensedStates = safeParse(
                                store?.profileItem?.data?.nurseProfile
                                  ?.licensed_states,
                              );
                              return licensedStates.length > 0
                                ? licensedStates.join(", ")
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowLicensedStatesModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() =>
                          setShowHasCompactNursingLicenseModal(true)
                        }
                      >
                        <div className="content">
                          <label>Has compact nursing license</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.has_compact_license === true
                              ? "Yes"
                              : store?.profileItem?.data?.nurseProfile
                                  ?.has_compact_license === false
                              ? "No"
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() =>
                            setShowHasCompactNursingLicenseModal(true)
                          }
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() =>
                          setShowIsLicenseHasBeenVerifiedModal(true)
                        }
                      >
                        <div className="content">
                          <label>Is license has been verified</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.license_verified === true
                              ? "Verified"
                              : store?.profileItem?.data?.nurseProfile
                                  ?.license_verified === false
                              ? "Not Verified"
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() =>
                            setShowIsLicenseHasBeenVerifiedModal(true)
                          }
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      {/* Location & Relocation */}
                      <div
                        className="form-group-item"
                        onClick={() => setShowNurseCurrentCityModal(true)}
                      >
                        <div className="content">
                          <label>Nurse current city and state</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.current_city
                              ? `${store.profileItem.data.nurseProfile.current_city}, ${store.profileItem.data.nurseProfile.current_state}`
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowNurseCurrentCityModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowCityModal(true)}
                      >
                        <div className="content">
                          <label>In which state do you work?</label>
                          {/* <p>
                          {store?.profileItem?.data?.work_city}{" "}
                          {currentCities.destination.state?.label
                            ? `${currentCities.destination.state.label}, ${currentCities.destination.city?.label}`
                            : store?.profileItem?.data?.work_state
                            ? store?.profileItem?.data?.work_state
                            : "Not Set"}
                        </p> */}
                          <p>
                            {currentCities?.destination?.state?.label &&
                            currentCities?.destination?.city?.label
                              ? `${currentCities.destination.city.label}, ${currentCities.destination.state.label}`
                              : store?.profileItem?.data?.work_city &&
                                store?.profileItem?.data?.work_state
                              ? `${store.profileItem.data.work_city}, ${store.profileItem.data.work_state}`
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowCityModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowCityModal(true)}
                      >
                        <div className="content">
                          <label>In which state do you live?</label>
                          {/* <p>
                          {store?.profileItem?.data?.city}{" "}
                          {currentCities.destination.state?.label
                            ? `${currentCities.destination.state.label}, ${currentCities.destination.city?.label}`
                            : store?.profileItem?.data?.living_state
                            ? store?.profileItem?.data?.living_state
                            : "Not Set"}
                        </p> */}
                          <p>
                            {currentCities?.destination?.state?.label &&
                            currentCities?.destination?.city?.label
                              ? `${currentCities.destination.city.label}, ${currentCities.destination.state.label}`
                              : store?.profileItem?.data?.city
                              ? `${store.profileItem.data.city}${
                                  store.profileItem.data.living_state
                                    ? `, ${store.profileItem.data.living_state}`
                                    : ""
                                }`
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowCityModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowWillingToRelocateModal(true)}
                      >
                        <div className="content">
                          <label>Willing to relocate</label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.willing_to_relocate
                              ? store.profileItem.data.nurseProfile.willing_to_relocate
                                  .charAt(0)
                                  .toUpperCase() +
                                store.profileItem.data.nurseProfile.willing_to_relocate.slice(
                                  1,
                                )
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowWillingToRelocateModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowDestinationModal(true)}
                      >
                        <div className="content">
                          <label>What state(s) are you interested in?</label>
                          {(() => {
                            const interestedStates = safeParse(
                              store?.profileItem?.data?.interested_state,
                            );
                            const stateList = interestedStates
                              .map((item) => item?.state)
                              .filter(Boolean)
                              .join(", ");
                            return stateList ? (
                              <p>{stateList}</p>
                            ) : (
                              <p>Not Set</p>
                            );
                          })()}
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowDestinationModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowPreferredStatesModal(true)}
                      >
                        <div className="content">
                          <label>Preferred relocation states</label>
                          <p>
                            {(() => {
                              const preferredStates = safeParse(
                                store?.profileItem?.data?.nurseProfile
                                  ?.preferred_relocation_states,
                              );
                              return preferredStates.length > 0
                                ? preferredStates.join(", ")
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowPreferredStatesModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowLocationChoiceModal(true)}
                      >
                        <div className="content">
                          <label>
                            Which factors are most important in your location
                            choice?
                          </label>
                          <p>
                            {(() => {
                              const locations = safeParse(
                                store?.profileItem?.data?.location_choices_for,
                              );
                              return locations.length > 0
                                ? locations
                                    .slice(0, 2)
                                    .map((item, index, arr) => (
                                      <span key={index}>
                                        {item?.location_title}
                                        {index < arr.length - 1 ? ", " : ""}
                                      </span>
                                    ))
                                : currentLocationChoice?.value;
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowLocationChoiceModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      {/* Salary & Preferences */}
                      <div
                        className="form-group-item"
                        onClick={() => setShowSalaryModal(true)}
                      >
                        <div className="content">
                          <label>Preferred salary</label>
                          <p>
                            {store?.profileItem?.data?.preferred_salary
                              ? `$${Number(
                                  store?.profileItem?.data?.preferred_salary,
                                ).toLocaleString()}/Year`
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowSalaryModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowShiftPreferencesModal(true)}
                      >
                        <div className="content">
                          <label>Shift Preferences</label>
                          <p>
                            {(() => {
                              const shiftPreferences = safeParse(
                                store?.profileItem?.data?.nurseProfile
                                  ?.shift_preferences,
                              );
                              return shiftPreferences.length > 0
                                ? shiftPreferences.join(", ")
                                : "Not Set";
                            })()}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowShiftPreferencesModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item"
                        onClick={() => setShowPreferencesConfirmedModal(true)}
                      >
                        <div className="content">
                          <label>
                            Whether user preferences have been confirmed
                          </label>
                          <p>
                            {store?.profileItem?.data?.nurseProfile
                              ?.preferences_confirmed === true
                              ? "Yes"
                              : store?.profileItem?.data?.nurseProfile
                                  ?.preferences_confirmed === false
                              ? "No"
                              : "Not Set"}
                          </p>
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowPreferencesConfirmedModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      {/* Documents */}
                      <div
                        className="form-group-item eye"
                        onClick={() => setShowContractModal(true)}
                      >
                        <div className="content">
                          <div className="label-p">
                            <label>My contract Document</label>
                            <p>application/doc</p>
                          </div>
                          {!contractFile ? (
                            <button className="btn btn-link p-0 text-decoration-none">
                              {" "}
                            </button>
                          ) : (
                            <button
                              className="btn btn-link p-0 text-decoration-none"
                              onClick={() =>
                                window.open(contractFile, "_blank")
                              }
                            >
                              <EyeIcon size={16} />
                            </button>
                          )}
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setShowContractModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>

                      <div
                        className="form-group-item eye"
                        onClick={(e) => {
                          e.preventDefault();
                          if (secondContractFile) {
                            if (typeof secondContractFile === "string") {
                              window.open(secondContractFile, "_blank");
                            } else if (
                              secondContractFile instanceof File ||
                              secondContractFile instanceof Blob
                            ) {
                              window.open(
                                URL.createObjectURL(secondContractFile),
                                "_blank",
                              );
                            }
                          }
                        }}
                      >
                        <div
                          className="content"
                          onClick={() => setSecondShowContractModal(true)}
                        >
                          <div className="label-p">
                            <label>My pay stubs document</label>
                            <p>application/doc</p>
                          </div>
                          {!secondContractFile ? (
                            <button className="btn btn-link p-0 text-decoration-none">
                              {" "}
                            </button>
                          ) : (
                            <button
                              className="btn btn-link p-0 text-decoration-none"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (secondContractFile) {
                                  if (typeof secondContractFile === "string") {
                                    window.open(secondContractFile, "_blank");
                                  } else if (
                                    secondContractFile instanceof File ||
                                    secondContractFile instanceof Blob
                                  ) {
                                    window.open(
                                      URL.createObjectURL(secondContractFile),
                                      "_blank",
                                    );
                                  }
                                }
                              }}
                            >
                              <EyeIcon size={16} />
                            </button>
                          )}
                        </div>
                        <button
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={() => setSecondShowContractModal(true)}
                        >
                          <img src={Edit} alt="Edit" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <EditProfileModal
            show={showEditProfileModal}
            onHide={() => setShowEditProfileModal(false)}
            profileData={profile}
            onSave={handleModalSave}
          />
          <EmploymentTypeModal
            show={showEmploymentModal}
            onHide={() => setShowEmploymentModal(false)}
            isApplyPage={false}
          />
          <EmrSystemsModal
            show={showEmrSystemsModal}
            onHide={() => setShowEmrSystemsModal(false)}
            isApplyPage={false}
          />
          <ShiftPreferencesModal
            show={showShiftPreferencesModal}
            onHide={() => setShowShiftPreferencesModal(false)}
            isApplyPage={false}
          />
          <LicensedStatesModal
            show={showLicensedStatesModal}
            onHide={() => setShowLicensedStatesModal(false)}
            isApplyPage={false}
          />
          <AdditionalSpecialtiesModal
            show={showAdditionalSpecialtiesModal}
            onHide={() => setShowAdditionalSpecialtiesModal(false)}
            isApplyPage={false}
          />
          <PreferredStatesModal
            show={showPreferredStatesModal}
            onHide={() => setShowPreferredStatesModal(false)}
            isApplyPage={false}
          />
          <PreferencesConfirmedModal
            show={showPreferencesConfirmedModal}
            onHide={() => setShowPreferencesConfirmedModal(false)}
            isApplyPage={false}
          />
          <AvailabilitySetModal
            show={showAvailabilitySetModal}
            onHide={() => setShowAvailabilitySetModal(false)}
            isApplyPage={false}
          />
          <ResumeUrlModal
            show={showResumeUrlModal}
            onHide={() => setShowResumeUrlModal(false)}
            isApplyPage={false}
          />
          <ResumeUploadedModal
            show={showResumeUploadedModal}
            onHide={() => setShowResumeUploadedModal(false)}
            isApplyPage={false}
          />
          <CertsUploadedModal
            show={showCertsUploadedModal}
            onHide={() => setShowCertsUploadedModal(false)}
            isApplyPage={false}
          />
          <TraumaLevelExperienceModal
            show={showTraumaLevelExperienceModal}
            onHide={() => setShowTraumaLevelExperienceModal(false)}
            isApplyPage={false}
          />
          <PatientPopulationModal
            show={showPatientPopulationModal}
            onHide={() => setShowPatientPopulationModal(false)}
            isApplyPage={false}
          />
          <BedsideLast12MonthsModal
            show={showBedsideLast12MonthsModal}
            onHide={() => setShowBedsideLast12MonthsModal(false)}
            isApplyPage={false}
          />
          <EducationModal
            show={showNursingEducationLevelModal}
            onHide={() => setShowNursingEducationLevelModal(false)}
            isApplyPage={false}
          />
          <AvailableToStartModal
            show={showAvailableToStartModal}
            onHide={() => setShowAvailableToStartModal(false)}
            isApplyPage={false}
          />
          <PrimarySpecialtyModal
            show={showPrimarySpecialtyModal}
            onHide={() => setShowPrimarySpecialtyModal(false)}
            isApplyPage={false}
          />
          <YearsExperienceModal
            show={showYearsExperienceModal}
            onHide={() => setShowYearsExperienceModal(false)}
          />
          <LicenseVerifiedModal
            show={showIsLicenseHasBeenVerifiedModal}
            onHide={() => setShowIsLicenseHasBeenVerifiedModal(false)}
            isApplyPage={false}
          />
          <LicenseNumberModal
            show={showLicenseNumberModal}
            onHide={() => setShowLicenseNumberModal(false)}
            isApplyPage={false}
          />
          <CompactLicenseModal
            show={showHasCompactNursingLicenseModal}
            onHide={() => setShowHasCompactNursingLicenseModal(false)}
          />
          <LicenseTypeModal
            show={showLicenseTypeModal}
            onHide={() => setShowLicenseTypeModal(false)}
            isApplyPage={false}
          />
          <RelocationModal
            show={showWillingToRelocateModal}
            onHide={() => setShowWillingToRelocateModal(false)}
            isApplyPage={false}
          />
          <NurseCurrentCityModal
            show={showNurseCurrentCityModal}
            onHide={() => setShowNurseCurrentCityModal(false)}
          />
          <CareerObjectivesModal
            show={showCareerObjectiveModal}
            onHide={() => setShowCareerObjectiveModal(false)}
          />
          <CommunityNotificationModal
            show={showCommunityNotificationModal}
            onHide={() =>
              closeModalAndClearParam(setShowCommunityNotificationModal)
            }
            category="community"
          />
          <JobsNotificationModal
            show={showJobsNotificationModal}
            onHide={() => closeModalAndClearParam(setShowJobsNotificationModal)}
            category="jobs"
          />
          <FeatureNotificationModal
            show={showFeaturesNotificationModal}
            onHide={() =>
              closeModalAndClearParam(setShowFeaturesNotificationModal)
            }
            category="features"
          />
          <NewsletterNotificationModal
            show={showNewsletterNotificationModal}
            onHide={() =>
              closeModalAndClearParam(setShowNewsletterNotificationModal)
            }
            category="newsletter"
          />
          <SystemNotificationModal
            show={showSystemNotificationModal}
            onHide={() =>
              closeModalAndClearParam(setShowSystemNotificationModal)
            }
            category="system"
          />
          <PromotionsNotificationModal
            show={showPromotionsNotificationModal}
            onHide={() =>
              closeModalAndClearParam(setShowPromotionsNotificationModal)
            }
            category="promotions"
          />
          {/* Career Objectives for new modal */}
          <RoleSelectionModal
            show={showRoleModal}
            onHide={() => setShowRoleModal(false)}
            // selectedRole={currentRole.value}
            selectedRole={store?.profileItem?.data?.nursing_role}
            onSave={
              (newRole) => setCurrentRole({ value: newRole, isEditing: false }) // ✅ update state
            }
          />
          <ShiftTypeModal
            show={showShiftModal}
            onHide={() => setShowShiftModal(false)}
          />
          <CertificateModal
            show={showCertificateModal}
            onHide={() => setShowCertificateModal(false)}
            isApplyPage={false}
          />

          <SalaryModal
            show={showSalaryModal}
            onHide={() => setShowSalaryModal(false)}
            isApplyPage={false}
          />
          <YearsOfExperienceModal
            show={showExperienceModal}
            onHide={() => setShowExperienceModal(false)}
            selectedExperience={store?.profileItem?.data?.nursing_experience} // ✅ pass current experience
            onSave={
              (newExperience) =>
                setNursingExperience({ value: newExperience, isEditing: false }) // ✅ update state
            }
            isApplyPage={false}
          />
          <LocationChoiceModal
            show={showLocationChoiceModal}
            onHide={() => setShowLocationChoiceModal(false)}
            selectedChoice={store?.profileItem?.data?.location_choices_for} // ✅ pass current choice
            onSave={
              (newChoice) =>
                setCurrentLocationChoice({ value: newChoice, isEditing: false }) // ✅ update state
            }
          />
          <CitySelectionModal
            show={showCityModal}
            onHide={() => setShowCityModal(false)}
            selectedCities={currentCities}
            onSave={(newCities) => setCurrentCities(newCities)}
          />
          <StateSelectionModal
            show={showDestinationModal}
            onHide={() => setShowDestinationModal(false)}
            selected={destinations}
            onSave={(selectedDestinations) => {
              setDestinations(selectedDestinations);
              setShowDestinationModal(false);
            }}
          />
          <SocialProfilesStep
            show={showSocialModal}
            onHide={() => setShowSocialModal(false)}
            profiles={socialProfiles}
            onSave={(updatedProfiles) => setSocialProfiles(updatedProfiles)}
          />
          <ContractSecondDocumentModal
            show={showSecondContractModal}
            onHide={() => setSecondShowContractModal(false)}
            documentFile={secondContractFile}
            onSave={(file) => setSecondContractFile(file)}
          />
          <ContractDocumentModal
            show={showContractModal}
            onHide={() => setShowContractModal(false)}
            documentFile={contractFile}
            onSave={(file) => setContractFile(file)}
          />
        </Card.Body>
      </Card>

      {/* "Your saved paychecks" — Phase 2 section for full-list management
          (rename / duplicate / delete). The horizontal chip row at the top
          of the Paycheck Calculator surfaces the same data. */}
      <SavedPaychecksSection />

      {/* "Saved cities" — Section for displaying bookmarked cities from the search page. */}
      <SavedCitiesSection />

      <div className="tab-popup-page-content">
        <div className="row">
          <div className="col-6 col-md-6">
            <button
              className="tab-box"
              onClick={() => navigate("/profile/subscription")}
              style={{ cursor: "pointer", position: "relative" }}
              data-tour="pf-sub"
            >
              <div className="icon-tab-name" style={{ pointerEvents: "none" }}>
                <div className="icon" style={{ pointerEvents: "none" }}>
                  <SubscriptionIcon />
                </div>
                <div className="tab-name" style={{ pointerEvents: "none" }}>
                  Subscription
                </div>
              </div>
              <div className="tab-arrow" style={{ pointerEvents: "none" }}>
                <RightArrowIcon />
              </div>
            </button>
          </div>

          <div className="col-6 col-md-6">
            <button
              className="tab-box"
              onClick={() => navigate("/contact-us")}
              style={{ cursor: "pointer", position: "relative" }}
            >
              <div className="icon-tab-name" style={{ pointerEvents: "none" }}>
                <div className="icon" style={{ pointerEvents: "none" }}>
                  <ContactUsIcon />
                </div>
                <div className="tab-name" style={{ pointerEvents: "none" }}>
                  Contact us
                </div>
              </div>
              <div className="tab-arrow" style={{ pointerEvents: "none" }}>
                <RightArrowIcon />
              </div>
            </button>
          </div>

          <div className="col-6 col-md-6">
            <button
              className="tab-box"
              onClick={() => navigate("/referral")}
              style={{ cursor: "pointer", position: "relative" }}
              data-tour="pf-ref"
            >
              <div className="icon-tab-name" style={{ pointerEvents: "none" }}>
                <div className="icon" style={{ pointerEvents: "none" }}>
                  <ReferralIcon />
                </div>
                <div className="tab-name" style={{ pointerEvents: "none" }}>
                  Referral
                </div>
              </div>
              <div className="tab-arrow" style={{ pointerEvents: "none" }}>
                <RightArrowIcon />
              </div>
            </button>
          </div>

          <div className="col-6 col-md-6">
            <button
              className="tab-box last-in-column last-overall"
              onClick={() => {
                if (isDemoSite()) {
                  showError("Not available in the demo");
                  return;
                }
                setShowDeleteAccountModal(true);
              }}
              style={{
                cursor: "pointer",
                position: "relative",
                opacity: isDemoSite() ? 0.5 : 1,
              }}
              data-tour="pf-delacct"
            >
              <div className="icon-tab-name" style={{ pointerEvents: "none" }}>
                <div className="icon" style={{ pointerEvents: "none" }}>
                  <DeleteIcon />
                </div>
                <div className="tab-name" style={{ pointerEvents: "none" }}>
                  Delete account
                </div>
              </div>
              <div className="tab-arrow" style={{ pointerEvents: "none" }}>
                <RightArrowIcon />
              </div>
            </button>
          </div>

          {regType !== "social" && (
            <div className="col-12 col-md-6">
              <button
                className={`tab-box ${
                  regType !== "social" ? "last-in-column" : ""
                }`}
                onClick={handleClickChangePassword}
                style={{
                  cursor: "pointer",
                  position: "relative",
                  opacity: isDemoSite() ? 0.5 : 1,
                }}
                data-tour="pf-pw"
              >
                <div
                  className="icon-tab-name"
                  style={{ pointerEvents: "none" }}
                >
                  <div className="icon" style={{ pointerEvents: "none" }}>
                    <ChangePasswordIcon />
                  </div>
                  <div className="tab-name" style={{ pointerEvents: "none" }}>
                    Change password
                  </div>
                </div>
                <div className="tab-arrow" style={{ pointerEvents: "none" }}>
                  <RightArrowIcon />
                </div>
              </button>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="md"
          dialogClassName="custom-modal"
        >
          <Modal.Header>
            <h5 className="modal-title">Change Password</h5>
            <Button className="close-btn" onClick={() => setShowModal(false)}>
              <FiX size={24} />
            </Button>
          </Modal.Header>

          <Modal.Body>
            <form
              className="change-pass-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              {/* Old password */}
              <Form.Group className="form-group password">
                <Form.Label className="col-label">Old Password</Form.Label>
                <input
                  type={showPassword.old ? "text" : "password"}
                  placeholder="Old Password"
                  className={`col-input ${errors.old ? "is-invalid" : ""}`}
                  {...register("old")}
                />
                <span className="icon" onClick={() => togglePassword("old")}>
                  {showPassword.old ? <Eye size={20} /> : <EyeOff size={20} />}
                </span>
                {errors.old && (
                  <div
                    className="alert alert-danger mt-2 d-flex align-items-center"
                    role="alert"
                    style={{ fontSize: "13px", padding: "8px 12px" }}
                  >
                    <FiAlertCircle className="me-2" size={16} />
                    <div>{errors.old.message}</div>
                  </div>
                )}
              </Form.Group>

              {/* New password */}
              <Form.Group className="form-group password">
                <Form.Label className="col-label">New Password</Form.Label>
                <input
                  type={showPassword.new ? "text" : "password"}
                  placeholder="New Password"
                  className={`col-input ${errors.new ? "is-invalid" : ""}`}
                  {...register("new")}
                />
                <span className="icon" onClick={() => togglePassword("new")}>
                  {showPassword.new ? <Eye size={20} /> : <EyeOff size={20} />}
                </span>
                {errors.new && (
                  <div
                    className="alert alert-danger mt-2 d-flex align-items-center"
                    role="alert"
                    style={{ fontSize: "13px", padding: "8px 12px" }}
                  >
                    <FiAlertCircle className="me-2" size={16} />
                    <div>{errors.new.message}</div>
                  </div>
                )}
              </Form.Group>

              {/* Confirm password */}
              <Form.Group className="form-group password">
                <Form.Label className="col-label">Confirm Password</Form.Label>
                <input
                  type={showPassword.confirm ? "text" : "password"}
                  placeholder="Confirm Password"
                  className={`col-input ${errors.confirm ? "is-invalid" : ""}`}
                  {...register("confirm")}
                />
                <span
                  className="icon"
                  onClick={() => togglePassword("confirm")}
                >
                  {showPassword.confirm ? (
                    <Eye size={20} />
                  ) : (
                    <EyeOff size={20} />
                  )}
                </span>
                {errors.confirm && (
                  <div
                    className="alert alert-danger mt-2 d-flex align-items-center"
                    role="alert"
                    style={{ fontSize: "13px", padding: "8px 12px" }}
                  >
                    <FiAlertCircle className="me-2" size={16} />
                    <div>{errors.confirm.message}</div>
                  </div>
                )}
              </Form.Group>

              {/* Feedback message */}
              {message && (
                <div
                  className="alert alert-success mt-3 d-flex align-items-center"
                  role="alert"
                  style={{ fontSize: "14px", padding: "10px 15px" }}
                >
                  <FiAlertCircle className="me-2" size={18} />
                  <div>{message}</div>
                </div>
              )}

              <Form.Group className="form-group mb-0">
                <button type="submit" className="btn btn-primary w-100">
                  {buttonText}
                </button>
              </Form.Group>
            </form>
          </Modal.Body>
        </Modal>
      )}

      <Modal
        show={showDeleteAccountModal}
        onHide={() => setShowDeleteAccountModal(false)}
        centered
        dialogClassName="custom-modal delete-modal-account"
      >
        <Modal.Body>
          <div className="icon">
            <DeleteAccountModalIcon />
          </div>
          <h3 className="title">Delete Account</h3>
          <p>Are you sure want to Delete Account?</p>

          <div className="actions">
            <Button
              className="px-4 py-2"
              variant="btn btn-secondary"
              onClick={() => {
                setShowDeleteAccountModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="btn btn-danger"
              className="px-4 py-2 d-flex align-items-center gap-2"
              onClick={handleDelete}
            >
              <FiAlertTriangle size={18} />
              Delete Permanently
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Followers Modal */}
      <FollowersModal
        show={showFollowersModal}
        onHide={() => {
          console.log("FollowersModal onHide called - calling getViewProfile");
          setShowFollowersModal(false);
          dispatch(getViewProfile()); // Refresh stats when modal closes
        }}
      />

      {/* Following Modal */}
      <FollowingModal
        show={showFollowingModal}
        onHide={() => {
          console.log("FollowingModal onHide called - calling getViewProfile");
          setShowFollowingModal(false);
          dispatch(getViewProfile()); // Refresh stats when modal closes
        }}
      />

      {/* Plan-badge upgrade modal commented out per request
      <UpgradePlanModal
        show={showUpgrade}
        onClose={() => setShowUpgrade(false)}
        source="profile_plan_badge"
      />
      */}

      {/* <button >click</button> */}
    </div>
  );
};

export default ProfileComponent;
